var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListAltNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4808 0.800781H1.52078C1.12078 0.800781 0.800781 1.12078 0.800781 1.52078V14.4808C0.800781 14.8008 1.12078 15.2008 1.52078 15.2008H14.4808C14.8008 15.2008 15.2008 14.8008 15.2008 14.4808V1.52078C15.2008 1.12078 14.8008 0.800781 14.4808 0.800781ZM5.602 4.00126H4.002V5.60126H5.602V4.00126ZM11.9999 4.00126H7.19986V5.60126H11.9999V4.00126ZM11.9999 7.20048H7.19986V8.80048H11.9999V7.20048ZM7.19986 10.401H11.9999V12.001H7.19986V10.401ZM4.002 7.20048H5.602V8.80048H4.002V7.20048ZM5.602 10.401H4.002V12.001H5.602V10.401ZM2.39887 13.6006H13.5989V2.40055H2.39887V13.6006Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListAltNew);
export default __webpack_public_path__ + "static/media/list_alt_new.3d3cbf7251a10df474db00a5c09e9a2a.svg";
export { ForwardRef as ReactComponent };